import React from 'react'

import { Button, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'

const HandleButton = ({ handleReset, handleApply, disableApply = false }) => {
  return (
    <Stack className="mt-4/2 border-grays-30 border-t px-3 py-3  ">
      <XStack className="justify-between">
        <Button
          className="bg-grays-20 mr-2 flex-grow"
          size={'lg'}
          textStyle="text-primary-100"
          onPress={handleReset}
        >
          {i18n.t('myLeads.clear')}
        </Button>
        <Button
          disabled={disableApply}
          onPress={handleApply}
          className={'ml-2 flex-grow'}
          size={'lg'}
        >
          {i18n.t('myLeads.apply')}
        </Button>
      </XStack>
    </Stack>
  )
}

export default HandleButton
